import i18n from 'i18next';
import { FullManagement, FullOrder, Management, Order } from 'assets/icons';

export interface Route {
  label: string;
  icon?: React.FC<React.SVGProps<SVGSVGElement>>;
  activeIcon?: React.FC<React.SVGProps<SVGSVGElement>>;
  path: string;
  subRoutes?: Route[];
}

const routes: Route[] = [
  {
    label: i18n.t('summary:title'),
    icon: Order,
    activeIcon: FullOrder,
    path: '/summary',
    subRoutes: [{ label: i18n.t('summary:title'), path: '/summary' }]
  },
  {
    label: i18n.t('shared:nav_autogestion'),
    icon: Management,
    activeIcon: FullManagement,
    path: '/products',
    subRoutes: [{ label: i18n.t('shared:nav_autogestion'), path: '/products' }]
  }
];

export default routes;
